import { MDBIcon } from "mdbreact";

export default function OfferAmenities({ offer }) {
  return (
    <div className="d-flex d-lg-block justify-content-between w-100 pt-5 pt-lg-0 flex-wrap paragraph">
      {offer.wiFi && (
        <p className="mx-2 mx-sm-4">
          <MDBIcon icon="wifi" className="moz-u-primary-color py-2 py-lg-3 " />{" "}
          - Besplatan Internet
        </p>
      )}

      {offer.bus && (
        <p className="mx-2 mx-sm-4">
          <MDBIcon icon="bus" className="moz-u-primary-color py-2 py-lg-3 " /> -
          Autobuski prevoz
        </p>
      )}

      {offer.dvoriste && (
        <p className="mx-2 mx-sm-4">
          <MDBIcon icon="tree" className="moz-u-primary-color py-2 py-lg-3 " />
          &nbsp;- Dvorište
        </p>
      )}

      {offer.tv && (
        <p className="mx-2 mx-sm-4">
          <MDBIcon icon="tv" className="moz-u-primary-color py-2 py-lg-3 " />
          &nbsp;- TV
        </p>
      )}

      {offer.klima && (
        <p className="mx-2 mx-sm-4">
          <MDBIcon
            icon="snowflake"
            className="moz-u-primary-color py-2 py-lg-3 "
          />
          &nbsp;- Klima
        </p>
      )}
      {offer.parking && (
        <p className="mx-2 mx-sm-4">
          <MDBIcon icon="car" className="moz-u-primary-color py-2 py-lg-3 " /> -
          Parking
        </p>
      )}
      {offer.kuhinja && (
        <p className="mx-2 mx-sm-4">
          <MDBIcon
            icon="utensils"
            className="moz-u-primary-color py-2 py-lg-3 "
          />
          &nbsp;- Kuhinja
        </p>
      )}
    </div>
  );
}
